import { isValidZoneCountryCode } from "./zoneCountryOptions";

export const MAX_PRODUCT_BADGE_COUNT = 4;

export const PRODUCT_BADGE_OPTIONS = [
  {
    value: "most_ordered",
    label: "Most Ordered",
    description: "Highest sales",
    icon: "⭐",
    placeholder: "",
  },
  {
    value: "best_seller",
    label: "Best Seller",
    description: "Customer favorite",
    icon: "🔥",
    placeholder: "",
  },
  {
    value: "chefs_choice",
    label: "Chef's Choice",
    description: "Chef recommendation",
    icon: "👨‍🍳",
    placeholder: "",
  },
  {
    value: "fresh_daily",
    label: "Fresh Daily",
    description: "Prepared fresh",
    icon: "🌿",
    placeholder: "",
  },
  {
    value: "traditional",
    label: "Traditional",
    description: "Authentic local recipe",
    icon: "🏺",
    placeholder: "",
  },
  {
    value: "international",
    label: "International",
    description: "Foreign cuisine",
    icon: "🌍",
    placeholder: "",
  },
  {
    value: "high_protein",
    label: "High Protein",
    description: "High nutritional value",
    icon: "💪",
    placeholder: "",
  },
  {
    value: "healthy_choice",
    label: "Healthy Choice",
    description: "Balanced and nutritious",
    icon: "🥗",
    placeholder: "",
  },
  {
    value: "vegan",
    label: "Vegan",
    description: "Plant-based",
    icon: "🌱",
    placeholder: "",
  },
  {
    value: "mediterranean",
    label: "Mediterranean",
    description: "Mediterranean cuisine",
    icon: "🫒",
    placeholder: "",
  },
  {
    value: "asian",
    label: "Asian",
    description: "Asian cuisine",
    icon: "🥢",
    placeholder: "",
  },
  {
    value: "oriental",
    label: "Oriental",
    description: "Middle Eastern & Maghreb",
    icon: "🧆",
    placeholder: "",
  },
  {
    value: "latin",
    label: "Latin",
    description: "Latin American cuisine",
    icon: "🌮",
    placeholder: "",
  },
  {
    value: "north_african",
    label: "North African",
    description: "Tunisia, Morocco, Algeria, Egypt",
    icon: "🌍",
    placeholder: "",
  },
  {
    value: "west_african",
    label: "West African",
    description: "Nigeria, Ghana, Senegal",
    icon: "🌍",
    placeholder: "",
  },
  {
    value: "east_african",
    label: "East African",
    description: "Ethiopia, Kenya, Tanzania",
    icon: "🌍",
    placeholder: "",
  },
  {
    value: "southern_african",
    label: "Southern African",
    description: "South Africa, Namibia",
    icon: "🌍",
    placeholder: "",
  },
  {
    value: "middle_eastern",
    label: "Middle Eastern",
    description: "UAE, Saudi Arabia, Qatar",
    icon: "🏜️",
    placeholder: "",
  },
  {
    value: "levantine",
    label: "Levantine",
    description: "Lebanon, Jordan, Syria, Palestine",
    icon: "🌿",
    placeholder: "",
  },
  {
    value: "south_asian",
    label: "South Asian",
    description: "India, Pakistan, Bangladesh, Sri Lanka",
    icon: "🌏",
    placeholder: "",
  },
  {
    value: "east_asian",
    label: "East Asian",
    description: "China, Japan, South Korea",
    icon: "🥢",
    placeholder: "",
  },
  {
    value: "southeast_asian",
    label: "Southeast Asian",
    description: "Thailand, Vietnam, Malaysia, Indonesia",
    icon: "🌴",
    placeholder: "",
  },
  {
    value: "tropical",
    label: "Tropical",
    description: "Islands & equatorial flavors",
    icon: "🥥",
    placeholder: "",
  },
  {
    value: "caribbean",
    label: "Caribbean",
    description: "Jamaica, Cuba, Dominican Republic",
    icon: "🏝️",
    placeholder: "",
  },
  {
    value: "polynesian_pacific",
    label: "Polynesian & Pacific",
    description: "Fiji, Samoa, Tahiti",
    icon: "🌺",
    placeholder: "",
  },
  {
    value: "mexican",
    label: "Mexican",
    description: "Tacos, burritos, mole",
    icon: "🌮",
    placeholder: "",
  },
  {
    value: "central_american",
    label: "Central American",
    description: "Pupusas, tamales",
    icon: "🫔",
    placeholder: "",
  },
  {
    value: "south_american",
    label: "South American",
    description: "Brazil, Argentina, Peru",
    icon: "🥩",
    placeholder: "",
  },
  {
    value: "north_american",
    label: "North American",
    description: "United States, Canada",
    icon: "🍔",
    placeholder: "",
  },
  {
    value: "nordic_scandinavian",
    label: "Nordic & Scandinavian",
    description: "Sweden, Norway, Denmark, Finland",
    icon: "❄️",
    placeholder: "",
  },
  {
    value: "french",
    label: "French",
    description: "Fine dining, sauces, pastries",
    icon: "🥐",
    placeholder: "",
  },
  {
    value: "german_austrian",
    label: "German & Austrian",
    description: "Schnitzel, sausages",
    icon: "🥨",
    placeholder: "",
  },
  {
    value: "eastern_european",
    label: "Eastern European",
    description: "Pierogi, goulash, borscht",
    icon: "🥟",
    placeholder: "",
  },
  {
    value: "zone",
    label: "Country",
    description: "Country of origin (flag)",
    icon: "🏳️",
    placeholder: "Select a country flag",
  },
  {
    value: "promo",
    label: "Promo",
    description: "Special offer",
    icon: "🎁",
    placeholder: "",
  },
  {
    value: "customized",
    label: "Customized",
    description: "Add one or more labels",
    icon: "🏷️",
    placeholder: "Custom badge label (required)",
  },
];

export const DEFAULT_CUSTOM_BADGE_ICON =
  PRODUCT_BADGE_OPTIONS.find((option) => option.value === "customized")?.icon || "🏷️";

/**
 * The user supplies only the icon reference for a customized badge:
 * either an emoji/symbol ("🌶️") or a FontAwesome reference
 * ("fa-solid fa-pepper-hot", "fas fa-fire", "fa-fire").
 */
export function isFontAwesomeIconRef(value) {
  const ref = String(value || "").trim();
  return (
    /^fa-[a-z0-9-]+$/i.test(ref) ||
    /^(fa|fas|far|fab|fa-solid|fa-regular|fa-brands|fa-light|fa-duotone)\s+fa-[a-z0-9-]+$/i.test(ref)
  );
}

export function normalizeFontAwesomeIconRef(value) {
  const ref = String(value || "").trim().replace(/\s+/g, " ");
  if (/^fa-[a-z0-9-]+$/i.test(ref)) return `fas ${ref}`;
  if (/^fa\s+/i.test(ref)) return ref.replace(/^fa\s+/i, "fas ");
  return ref;
}

/** Icon to render for a badge: the user's own icon for customized, else the preset one. */
export function getProductBadgeDisplayIcon(item) {
  if (item?.type === "customized" && String(item.icon || "").trim()) {
    return String(item.icon).trim();
  }
  return getProductBadgeOption(item?.type).icon;
}

export const VALID_PRODUCT_BADGE_TYPES = PRODUCT_BADGE_OPTIONS.map(
  (option) => option.value
);

const LEGACY_PRODUCT_BADGE_MAP = {
  best_seller: "best_seller",
  customized: "customized",
};

export function getProductBadgeOption(type) {
  return (
    PRODUCT_BADGE_OPTIONS.find((option) => option.value === type) ||
    PRODUCT_BADGE_OPTIONS[0]
  );
}

export function cleanBadgeIconName(value) {
  const raw = String(value || "").trim();
  if (!raw || raw.length > 180 || /[\\/]|\.\./.test(raw)) return "";
  return /^[\w.\-]+$/.test(raw) ? raw : "";
}

export function migrateLegacyProductBadge(legacyBadge) {
  const mapped = LEGACY_PRODUCT_BADGE_MAP[legacyBadge];
  if (!mapped) return [];
  return [{ type: mapped, value: "" }];
}

const BADGE_TYPES_REQUIRING_VALUE = new Set(["customized", "zone"]);

export function normalizeProductBadgesForSave(items, legacyBadge = "") {
  const source = Array.isArray(items) && items.length
    ? items
    : migrateLegacyProductBadge(legacyBadge);

  const seen = new Set();

  return source
    .filter((item) => VALID_PRODUCT_BADGE_TYPES.includes(item?.type))
    .filter((item) => {
      if (BADGE_TYPES_REQUIRING_VALUE.has(item.type) && !String(item.value || "").trim()) {
        return false;
      }
      if (item.type === "zone" && !isValidZoneCountryCode(item.value)) {
        return false;
      }
      const key =
        item.type === "customized"
          ? `customized:${String(item.value || "").trim().toLowerCase()}`
          : item.type;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, MAX_PRODUCT_BADGE_COUNT)
    .map((item) => {
      const normalized = {
        type: item.type,
        value: String(item.value || "").trim(),
      };
      // Only customized badges carry the user-supplied icon reference.
      if (item.type === "customized") {
        const icon = String(item.icon || "").trim().slice(0, 64);
        if (icon) normalized.icon = icon;
      }
      return normalized;
    });
}
